import { render, staticRenderFns } from "./stepActive.vue?vue&type=template&id=2a31aae4&scoped=true&"
import script from "./stepActive.vue?vue&type=script&lang=js&"
export * from "./stepActive.vue?vue&type=script&lang=js&"
import style0 from "./stepActive.vue?vue&type=style&index=0&id=2a31aae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a31aae4",
  null
  
)

export default component.exports